import axios from '@/utils/request';

// 获取讲师类别
export const getLecturerCatalogs = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturerCatalogs',
    method: 'GET',
    params: data,
  });
};

// 获取讲师列表
export const getLecturers = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturers',
    method: 'GET',
    params: data,
  });
};

// 获取讲师详情
export const getLecturerDetails = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturerDetails',
    method: 'GET',
    params: data,
  });
};

// 获取讲师线上课程
export const getOnLineCourseList = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetOnLineCourseList',
    method: 'GET',
    params: data,
  });
};

// 获取讲师线下课程
export const getOffLineCourseList = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetOffLineCourseList',
    method: 'GET',
    params: data,
  });
};

// 获取讲师评选活动
export const getVoteDetails = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturerVoteDetails',
    method: 'GET',
    params: data,
  });
};

// 获取讲师评选列表
export const getVoteTeachers = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturerVoteTeachers',
    method: 'GET',
    params: data,
  });
};

// 获取讲师投票排名--前三名
export const getVoteRankTop = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturerVoteRankTop',
    method: 'GET',
    params: data,
  });
};

// 获取讲师投票排名--从第四名开始
export const getVoteRank = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturerVoteRank',
    method: 'GET',
    params: data,
  });
};

// 投票
export const Vote = (data: any) => {
  return axios.request({
    url: 'Lecturer/Vote',
    method: 'POST',
    params: data,
  });
};

// 提交讲师评价
export const postLecturerEvaluation = (data: any) => {
  return axios.request({
    url: 'Lecturer/PostLecturerEvaluation',
    method: 'POST',
    data,
  });
};

// 获取讲师评价
export const getLecturerEvaluation = (data: any) => {
  return axios.request({
    url: 'Lecturer/GetLecturerEvaluation',
    method: 'GET',
    params: data,
  });
};
